import { render, staticRenderFns } from "./Stap5a.vue?vue&type=template&id=475fa256&"
import script from "./Stap5a.vue?vue&type=script&lang=js&"
export * from "./Stap5a.vue?vue&type=script&lang=js&"
import style0 from "./Stap5a.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports